module.exports = __webpack_public_path__ + "img/fig27.e258365d.jpg";